export default class GetHeaders {
  static dataHeaders() {
    return this.buildHeaders("data");
  }
  static projectHeaders() {
    return this.buildHeaders("project");
  }
  static buildHeaders(requestedDataSource = "data") {
    const jwt = localStorage.getItem("jwt");
    if (!jwt) {
      return;
    }
    return {
      Authorization: "Bearer " + jwt,
      "Requested-Data-Source": requestedDataSource,
      "Content-Type": 'multipart/form-data',
      "Cache-Control": 'no-store'
    };
  }
}
